<template>
  <r-modal v-model:isactive="localShow" :title="localTitle" width="600px">
    <div class="form-row">
      <r-input v-model="form.name" label="Ad" />
    </div>
    <div class="form-row">
      <r-textarea v-model="form.description" label="Açıklama" />
    </div>
    <div class="form-row">
      <r-select
        v-model="form.dataType"
        label="Veri Tipi"
        :data="dataTypes"
        txt="txt"
        val="val"
      />
      <r-select
        v-model="form.displayType"
        label="Görünüm"
        :data="displayTypes"
        txt="txt"
        val="val"
      />
    </div>
    <div class="form-row">
      <r-select
        v-model="form.cardinality"
        label="Çokluk"
        :data="cardinalities"
        txt="txt"
        val="val"
      />
      <r-checkbox v-model="form.isRequired" label="Zorunlu" />
    </div>
    <div class="form-row">
      <r-input v-model.number="form.sortOrder" type="number" label="Sıra" />
    </div>
    <div class="form-row" v-if="needsValues">
      <r-textarea
        v-model="valuesText"
        label="Seçenekler"
        placeholder="deger|Görünen Ad\nkolay|Kolay\norta|Orta\nzor|Zor"
      />
    </div>
    <small v-if="needsValues">
      Her satır bir seçenek olacak şekilde girin. 'deger|Görünen Ad' formatını
      kullanabilirsiniz.
    </small>
    <template v-slot:otherbuttons>
      <r-btn @click="onSave" size="medium">Kaydet</r-btn>
    </template>
  </r-modal>
</template>

<script>
import { ref, watch, computed } from "vue";

export default {
  name: "PropertyDefinitionModal",
  props: {
    modelValue: { type: Boolean, default: false },
    definition: { type: Object, default: null },
    title: { type: String, default: "" },
    defaultSortOrder: { type: Number, default: 1 }
  },
  emits: ["update:modelValue", "save"],
  setup(props, { emit }) {
    const localShow = ref(props.modelValue);
    const localTitle = computed(
      () => props.title || (form.value.id ? "Özellik Düzenle" : "Yeni Özellik")
    );
    const form = ref({
      id: null,
      name: "",
      description: "",
      dataType: 1,
      displayType: 1,
      cardinality: 1,
      isRequired: false,
      sortOrder: props.defaultSortOrder,
      isActive: true
    });
    const valuesText = ref("");

    const dataTypes = ref([
      { txt: "String", val: 1 },
      { txt: "Number", val: 2 },
      { txt: "Boolean", val: 3 },
      { txt: "Date", val: 4 },
      { txt: "DateTime", val: 5 },
      { txt: "Decimal", val: 6 },
      { txt: "Json", val: 7 }
    ]);
    const cardinalities = ref([
      { txt: "Single", val: 1 },
      { txt: "Multiple", val: 2 }
    ]);
    const displayTypes = ref([
      { txt: "TextBox", val: 1 },
      { txt: "TextArea", val: 2 },
      { txt: "Dropdown", val: 3 },
      { txt: "CheckboxList", val: 4 },
      { txt: "RadioButton", val: 5 },
      { txt: "NumberInput", val: 6 },
      { txt: "DatePicker", val: 7 },
      { txt: "BooleanCheckbox", val: 8 }
    ]);

    watch(
      () => props.modelValue,
      v => {
        localShow.value = v;
      }
    );
    watch(
      () => localShow.value,
      v => emit("update:modelValue", v)
    );
    watch(
      () => props.definition,
      v => {
        if (v && typeof v === "object") {
          form.value = { ...v };
          // Values'ları textarea'ya formatla
          const values = v.values || v.propertyDefinitionValues || [];
          if (Array.isArray(values) && values.length > 0) {
            valuesText.value = values
              .filter(val => val && val.value)
              .map(val => {
                const value = val.value || "";
                const display = val.displayText || val.value || "";
                return `${value}|${display}`;
              })
              .join("\n");
          } else {
            valuesText.value = "";
          }
        } else {
          form.value = {
            id: null,
            name: "",
            description: "",
            dataType: 1,
            displayType: 1,
            cardinality: 1,
            isRequired: false,
            sortOrder: props.defaultSortOrder,
            isActive: true
          };
          valuesText.value = "";
        }
      },
      { immediate: true }
    );

    const needsValues = computed(() => {
      const card = Number(form.value.cardinality);
      const disp = Number(form.value.displayType);
      return card === 2 || [3, 4, 5].includes(disp);
    });

    const onSave = () => {
      //debugger
      if (!form.value.name) return;
      let parsed = [];
      if (needsValues.value && valuesText.value) {
        parsed = valuesText.value
          .split("\n")
          .map(l => l.trim())
          .filter(Boolean)
          .map((l, i) => {
            const parts = l.split("|");
            const val = (parts[0] || "").trim();
            const disp = (parts[1] || parts[0] || "").trim();
            return {
              value: val,
              displayText: disp,
              sortOrder: i + 1,
              isActive: true
            };
          });
      }
      emit("save", { ...form.value, __values: parsed });
    };

    return {
      localShow,
      localTitle,
      form,
      dataTypes,
      cardinalities,
      displayTypes,
      valuesText,
      needsValues,
      onSave
    };
  }
};
</script>

<style scoped>
.form-row {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}
</style>
